import { Box, Field as ChakraField, Spacer } from '@chakra-ui/react';
import * as React from 'react';

export interface FieldProps extends Omit<ChakraField.RootProps, 'label'> {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  errorText?: React.ReactNode;
  optionalText?: React.ReactNode;
}

// There is some issue with field component theming so we are customizing it here
export const Field = React.forwardRef<HTMLDivElement, FieldProps>(
  function Field(props, ref) {
    const { label, children, helperText, errorText, optionalText, ...rest } =
      props;
    return (
      <ChakraField.Root ref={ref} {...rest}>
        {label && (
          <>
            <ChakraField.Label fontSize="xs" fontWeight="600">
              {label}
              <ChakraField.RequiredIndicator fallback={optionalText} />
            </ChakraField.Label>
            <Spacer h={2} />
          </>
        )}
        {children}
        {helperText && (
          <>
            <Spacer h={2} />
            <ChakraField.HelperText color="gray">
              {helperText}
            </ChakraField.HelperText>
          </>
        )}
        {errorText && (
          <>
            <Spacer h={2} />
            <ChakraField.ErrorText color="fgDanger">
              {errorText}
            </ChakraField.ErrorText>
          </>
        )}
      </ChakraField.Root>
    );
  }
);

export const FieldHorizontal = React.forwardRef<HTMLDivElement, FieldProps>(
  function FieldHorizontal(props, ref) {
    const { label, children, helperText, errorText, optionalText, ...rest } =
      props;
    return (
      <ChakraField.Root ref={ref} {...rest} orientation="horizontal">
        <Box>
          {label && (
            <ChakraField.Label fontSize="xs" fontWeight="600">
              {label}
              <ChakraField.RequiredIndicator fallback={optionalText} />
            </ChakraField.Label>
          )}
          {helperText && (
            <ChakraField.HelperText color="gray">
              {helperText}
            </ChakraField.HelperText>
          )}
          {errorText && (
            <ChakraField.ErrorText color="fgDanger">
              {errorText}
            </ChakraField.ErrorText>
          )}
        </Box>
        {children}
      </ChakraField.Root>
    );
  }
);
